import ApiService from "@/api.service";

export const GET_LIST_AREAS = "/admin/areas";
export const GET_LIST_PROVINCES = "/admin/provinces";
export const GET_LIST_DISTRICTS = "/admin/districts";
export const GET_LIST_WARDS = "/admin/wards";

export const SET_LIST_AREAS = "setListAreas";
export const SET_LIST_PROVINCES = "setListProvinces";
export const SET_LIST_DISTRICTS = "setListDistricts";
export const SET_LIST_WARDS = "setListWards";

const state = {
    areas: [],
    provinces: [],
    districts: [],
    wards: [],
};

const getters = {
    areas(state) {
        return state.areas;
    },
    provinces(state) {
        return state.provinces;
    },
    districts(state) {
        return state.districts;
    },
    wards(state) {
        return state.wards;
    },
};

const actions = {
    [GET_LIST_AREAS](context) {
        return new Promise(resolve => {
            ApiService.query(`${GET_LIST_AREAS}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_AREAS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PROVINCES](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${GET_LIST_PROVINCES}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PROVINCES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_DISTRICTS](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${GET_LIST_DISTRICTS}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_DISTRICTS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_WARDS](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${GET_LIST_WARDS}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_WARDS, data);
                }
                resolve(data);
            });
        });
    },
};

const mutations = {
    [SET_LIST_AREAS](state, data) {
        state.areas = data.data;
    },
    [SET_LIST_PROVINCES](state, data) {
        state.provinces = data.data;
    },
    [SET_LIST_DISTRICTS](state, data) {
        state.districts = data.data;
    },
    [SET_LIST_WARDS](state, data) {
        state.wards = data.data;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};